import {
  ApiFeedbackPayload,
  ApiFeedbackUResponese,
  ApiFileUploadPayload,
  ApiFileUploadResponese,
  ApiGetAwardInfoResponse,
  ApiGetUserFeedbackPayload,
  ApiGetUserFeedbackResponese
} from '@/api/feedback/type'
import { GlobalService } from '@/context'

/**
 * 附件上传接口
 */
export const apiFileUpload = (payload: ApiFileUploadPayload) =>
  GlobalService.upload<ApiFileUploadResponese>({
    url: '/customer/uploadFile',
    data: payload,
    customParams: {
      noEncrypt: true
    }
  }).then((res) => res.data.data as ApiFileUploadResponese)

/**
 * 有奖反馈接口
 */
export const apiFeedbackSend = (payload: ApiFeedbackPayload) =>
  GlobalService.post<ApiFeedbackUResponese>({
    url: '/customer/feedback',
    data: payload
  }).then((res) => res.data.data as ApiFeedbackUResponese)

/**
 * 获取用户反馈数据
 */
export const apiGetUserFeedback = (payload: ApiGetUserFeedbackPayload) =>
  GlobalService.post<ApiGetUserFeedbackResponese>({
    url: '/customer/getUserFeedback',
    data: payload
  }).then((res) => res.data.data as ApiGetUserFeedbackResponese)

/**
 * 获取奖励信息
 */
export const apiGetAwardInfo = (payload: { feedback: number }) =>
  GlobalService.post<ApiGetAwardInfoResponse>({
    url: '/customer/getAwardInfo',
    data: payload
  }).then((res) => res.data.data as ApiGetAwardInfoResponse)
